/*
 * CO-CRIE CONOSCO — gatilhos e envio do pop-up (sections/co-crie-popup.liquid).
 * Dirige o <x-modal> nativo do tema pela API publica (show/hide). Abre sozinho depois de N segundos (uma vez por
 * visitante, se configurado) e por qualquer link "#co-crie" ou [data-cocrie-open]. A validacao de verdade e no
 * servidor (n8n); aqui so a pre-checagem amigavel para nao mandar arquivo grande ou de tipo errado.
 */
(function () {
  'use strict';

  var SEEN_KEY = 'ls:cocrie:visto';
  var SENT_KEY = 'ls:cocrie:enviado';
  var MAX_BYTES = 5 * 1024 * 1024;
  var TIPOS = ['image/jpeg', 'image/png', 'image/webp'];

  function lsGet(k) { try { return window.localStorage.getItem(k); } catch (e) { return null; } }
  function lsSet(k, v) { try { window.localStorage.setItem(k, v); } catch (e) { /* noop */ } }

  function init(modal) {
    if (modal.hasAttribute('data-cocrie-ready')) return;
    modal.setAttribute('data-cocrie-ready', '');

    var form = modal.querySelector('form[data-cocrie-step="2"]');
    var err = modal.querySelector('[data-cocrie-error]');
    var count = modal.querySelector('[data-cocrie-count]');
    var submit = modal.querySelector('[data-cocrie-submit]');
    var openedAt = 0;

    function go(step) {
      modal.querySelectorAll('[data-cocrie-step]').forEach(function (el) {
        el.hidden = el.getAttribute('data-cocrie-step') !== String(step);
      });
      modal.classList.toggle('co-crie--form', step === 2);
      if (step === 2) {
        openedAt = Date.now();
        var first = form.querySelector('#cocrie-titulo');
        if (first) setTimeout(function () { first.focus(); }, 50);
      }
    }

    function showError(msg) { err.textContent = msg; err.hidden = !msg; }

    function open() {
      if (modal.open) return;
      if (window.LS_COCRIE_SETVH && !document.activeElement.matches('input, textarea')) window.LS_COCRIE_SETVH(true);
      go(1);
      modal.show();
    }

    modal.querySelector('[data-cocrie-next]').addEventListener('click', function () { go(2); });
    modal.querySelector('[data-cocrie-back]').addEventListener('click', function () { showError(''); go(1); });

    form.addEventListener('focusin', function (e) {
      var el = e.target;
      if (!el.matches || !el.matches('input, textarea')) return;
      setTimeout(function () { try { el.scrollIntoView({ block: 'center', behavior: 'smooth' }); } catch (x) {} }, 350);
    });

    var desc = form.querySelector('textarea[name="descricao"]');
    desc.addEventListener('input', function () { count.textContent = desc.value.length + '/2000'; });

    var fileInput = form.querySelector('input[name="arquivo"]');
    var upload = form.querySelector('[data-cocrie-upload]');
    var preview = upload.querySelector('.co-crie__upload-preview');
    var removeBtn = form.querySelector('[data-cocrie-remove]');
    var previewUrl = null;
    function clearFile() {
      fileInput.value = '';
      if (previewUrl) { URL.revokeObjectURL(previewUrl); previewUrl = null; }
      preview.hidden = true; preview.removeAttribute('src');
      upload.classList.remove('has-file'); removeBtn.hidden = true;
    }
    fileInput.addEventListener('change', function () {
      var f = fileInput.files && fileInput.files[0];
      if (!f) return clearFile();
      if (TIPOS.indexOf(f.type) === -1) { clearFile(); return showError('Envie uma imagem JPG, PNG ou WEBP.'); }
      if (f.size > MAX_BYTES) { clearFile(); return showError('A imagem passou de 5 MB. Escolha uma menor.'); }
      showError('');
      if (previewUrl) URL.revokeObjectURL(previewUrl);
      previewUrl = URL.createObjectURL(f);
      preview.src = previewUrl; preview.hidden = false;
      upload.classList.add('has-file'); removeBtn.hidden = false;
    });
    removeBtn.addEventListener('click', clearFile);

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      showError('');
      form.querySelectorAll('.is-invalid').forEach(function (el) { el.classList.remove('is-invalid'); });

      var invalid = Array.prototype.filter.call(form.querySelectorAll('[required]'), function (el) { return !el.checkValidity(); });
      if (invalid.length) {
        invalid.forEach(function (el) { el.classList.add('is-invalid'); });
        invalid[0].focus();
        return showError(invalid.some(function (el) { return el.type === 'checkbox'; }) && invalid.length === 1
          ? 'Para enviar, marque a autorização.' : 'Preencha os campos destacados.');
      }

      var data = new FormData(form);
      var file = data.get('arquivo');
      if (file && typeof file === 'object' && !file.size) data.delete('arquivo');
      data.append('t', String(Date.now() - openedAt));
      data.append('pagina', window.location.pathname.slice(0, 200));

      submit.disabled = true;
      submit.setAttribute('aria-busy', 'true');
      var label = submit.textContent;
      submit.textContent = 'Enviando…';

      var ctrl = typeof AbortController !== 'undefined' ? new AbortController() : null;
      var timer = ctrl ? setTimeout(function () { ctrl.abort(); }, 30000) : null;

      fetch(modal.getAttribute('data-endpoint'), { method: 'POST', body: data, signal: ctrl ? ctrl.signal : undefined })
        .then(function (r) { return r.json().catch(function () { return { ok: false }; }); })
        .then(function (res) {
          if (res && res.ok) {
            lsSet(SENT_KEY, 'true');
            lsSet(SEEN_KEY, 'true');
            form.reset();
            clearFile();
            count.textContent = '0/2000';
            go(3);
          } else {
            showError((res && res.motivo) || 'Não foi possível enviar agora. Tente de novo em instantes.');
          }
        })
        .catch(function () { showError('Não foi possível enviar agora. Confira sua conexão e tente de novo.'); })
        .finally(function () {
          if (timer) clearTimeout(timer);
          submit.disabled = false;
          submit.removeAttribute('aria-busy');
          submit.textContent = label;
        });
    });

    // Gatilhos: link #co-crie / [data-cocrie-open]
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a[href$="#co-crie"], [data-cocrie-open]');
      if (!a) return;
      e.preventDefault();
      open();
    });
    if (window.location.hash === '#co-crie') setTimeout(open, 300);

    // Abre sozinho uma vez (nunca por cima de outro modal aberto)
    var auto = modal.getAttribute('data-auto') === 'true';
    var onlyOnce = modal.getAttribute('data-only-once') === 'true';
    var delay = (parseInt(modal.getAttribute('data-delay'), 10) || 20) * 1000;
    if (auto && !(onlyOnce && lsGet(SEEN_KEY) === 'true') && lsGet(SENT_KEY) !== 'true') {
      setTimeout(function () {
        if (document.querySelector('x-modal[open], x-drawer[open], cart-drawer[open]')) return;
        lsSet(SEEN_KEY, 'true');
        open();
      }, delay);
    }
  }

  // Altura real da tela no celular (barra do iOS é sobreposição: innerHeight, não vh/dvh). Só muda quando a LARGURA muda
  // (rotação) ou ao abrir o pop-up — o teclado muda só a altura e não pode espremer o formulário.
  var lastW = 0;
  function setVh(force) {
    if (!force && window.innerWidth === lastW) return;
    lastW = window.innerWidth;
    document.documentElement.style.setProperty('--cocrie-h', window.innerHeight + 'px');
  }
  setVh(true);
  window.addEventListener('resize', function () { setVh(false); });
  window.addEventListener('orientationchange', function () { setTimeout(function () { setVh(true); }, 300); });
  window.LS_COCRIE_SETVH = setVh;

  // Área VISÍVEL (encolhe quando o teclado abre): o pop-up se prende ao topo dela e rola por dentro.
  function setVisual() {
    var v = window.visualViewport;
    var r = document.documentElement.style;
    r.setProperty('--cocrie-vv', (v ? v.height : window.innerHeight) + 'px');
    r.setProperty('--cocrie-vvtop', (v ? Math.max(0, v.offsetTop) : 0) + 'px');
  }
  setVisual();
  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', setVisual);
    window.visualViewport.addEventListener('scroll', setVisual);
  } else {
    window.addEventListener('resize', setVisual);
  }

  function boot() {
    var modal = document.querySelector('x-modal[data-cocrie]');
    if (!modal) return;
    if (window.customElements && window.customElements.whenDefined) {
      window.customElements.whenDefined('x-modal').then(function () { init(modal); });
    } else {
      init(modal);
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
